import { TFunction } from 'i18next';
import { TransactionCreationException } from '../interface/common';

export enum TransactionErrorField {
  MATTER = 'matter',
  TRANSACTION_DATE = 'transactionDate',
}

export interface ITransactionFieldError {
  field: TransactionErrorField;
  message: string;
}

export function getTransactionCreationFieldError(
  t: TFunction,
  apiErrorType?: string,
): ITransactionFieldError | null {
  switch (apiErrorType) {
    case TransactionCreationException.TransactionCustomerIdentificationErrorException: {
      return {
        field: TransactionErrorField.MATTER,
        message: t('transaction:error.customerIdentificationNotDoneForPrincipal'),
      };
    }
    case TransactionCreationException.CannotLinkToClosedMatterException: {
      return {
        field: TransactionErrorField.MATTER,
        message: t('transaction:error.matterIsClosed'),
      };
    }
    case TransactionCreationException.TransactionPostingPeriodDoesNotExistException: {
      return {
        field: TransactionErrorField.TRANSACTION_DATE,
        message: t('transaction:error.periodDoesNotExist'),
      };
    }
    case TransactionCreationException.TransactionServiceRestrictionErrorException: {
      return {
        field: TransactionErrorField.MATTER,
        message: t('transaction:restrictions.matterHasServiceRestriction'),
      };
    }
    default: {
      return null;
    }
  }
}
